import React from "react";
import { ReactComponent as NoDataImage } from "icons/no-data.svg";

type Props = {};

const NoData: React.FC<Props> = (): JSX.Element => {
  return (
    <div className="mt-24">
      <div className="flex flex-row h-full">
        <div className="my-auto mx-auto">
          <NoDataImage />
        </div>
      </div>
    </div>
  );
};

export default NoData;
